
// this file is automatically generated by git.version.ts script
export const versions = {
  version: '2.4.0.5',
  revision: '167cf794cfd95fcbb337f11b2012859e2ce71694',
  branch: 'master',
  channel: undefined,
  envTarget: undefined,
};